<template>
  <modal name="export">
    <card>
      <h4 v-if="!dateAt">Нажмите "Начать экспорт"</h4>
      <h4 v-else-if="dateAt">Процесс запущен {{ dateAt }}</h4>

      <button
        :disabled="isStarted"
        v-if="isStarted === false && isDone === false"
        class="btn btn-info btn-icon w-100"
        @click="start"
      >
        <span class="ti-upload"></span>
        Начать экспорт
      </button>

      <h4 v-if="isStarted === true && isDone === false">Идет выгрузка...</h4>

      <download-excel
        v-if="isDone === true"
        :data="data"
        :fields="exportFields"
        :name="'_export.xls'"
      >
        <button :disabled="isStarted" class="btn btn-info btn-icon w-100">
          <span class="ti-upload"></span> Скачать Excel
        </button>
      </download-excel>
      <hr />
      <button
        :disabled="isStarted"
        class="btn btn-warning btn-icon w-100"
        @click="cancel"
      >
        Отмена / сброс
      </button>
    </card>
  </modal>
</template>
<script>
import downloadExcel from "vue-json-excel";
export default {
  components: {
    downloadExcel,
  },
  name: "export",
  props: {
    exportFields: {
      default: function () {
        return {};
      },
    },
    params: {
      default: function () {
        return {};
      },
    },
    itemLink: {
      default: function () {
        return "";
      },
    },
  },
  methods: {
    cancel() {
      this.$modal.hide("export");
      this.isDone = false;
      this.isStarted = false;
      this.dateAt = null;
      this.data = [];
    },
    start() {
      this.$dialog
        .confirm(
          "Вы точно хотите начать экспорт? Это может занять несколько минут, в зависимости от кол-во товаров.",
          {
            okText: "Начать экспорт",
            cancelText: "Отмена",
          }
        )
        .then(() => {
          this.page = 1;
          this.data = [];
          this.$loading(true);
          this.isStarted = true;
          this.dateAt = new Date();
          this.export();
        })
        .catch(() => {});
    },

    async export() {
      let params = JSON.parse(JSON.stringify(this.params));
      params["page"] = this.page;
      params["per_page"] = 100;
      await this.$http
        .get(this.itemLink, {
          params: params,
        })
        .then((response) => {
          if (response.data && response.data.data) {
            if (response.data.data.length) {
              this.data.push(...response.data.data);
              this.page++;
              setTimeout(() => {
                this.export();
              }, 10);
            } else {
              this.isDone = true;
              this.isStarted = false;
              this.$loading(false);
            }
          }
        })
        .catch(() => {
          this.$loading(false);
        })
        .finally(() => {});
    },
  },
  data() {
    return {
      isStarted: false,
      isDone: false,
      dateAt: null,
      data: [],
      page: 1,
    };
  },
};
</script>
<style>
</style>
